<template>
  <div class="advocate-badge">
    <span
      v-if="hasCookiedAdvocate"
      class="text-xs">{{ $t('cac.app.cookie_welcome_back') }}</span>
    <div class="advocate-badge__container mt-2 d-flex align-items-center">
      <div class="d-flex flex-column advocate-badge__details">
        <span class="text-md text-semibold">{{ advocateName }}</span>
        <span class="text-sm mt-1">{{ advocateAddress }}</span>
      </div>
      <a
        :href="resetCookieUrl"
        class="text-xs"
      >
        {{ $t('cac.app.cookie_wrong_information') }}
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import STATE from "Constants/campaign/civicactioncenter/state";
import { upperFirst as _upperFirst } from "lodash";

const advocateCookieInfoContext = `${STATE.SCOPE_CAC}/${
  STATE.ADVOCATE_COOKIE_INFO
}`;
const advocateRecordContext = `${STATE.SCOPE_FORMS}/${STATE.ADVOCATE_RECORD}`;

export default {
  name: "AdvocateBadge",
  computed: {
    ...mapGetters({
      advocateCookieInfo: advocateCookieInfoContext,
      advocateRecord: advocateRecordContext
    }),
    advocateAddress() {
      // Returns a shorthand description of the advocate's address (i.e Rosslyn, VA 22209) if we have the city,
      // otherwise just the advocate's ZIP code followed by the city (22209 VA)
      return `${this.advocateInfo.city ? `${this.advocateInfo.city}, ` : ""} ${
        this.advocateInfo.state
      } ${this.advocateInfo.zip5}`;
    },
    advocateName() {
      const shortLastName = _upperFirst(
        this.advocateInfo.lastname
          ? `${this.advocateInfo.lastname.charAt(0)}.`
          : ""
      );
      const firstName = _upperFirst(this.advocateInfo.firstname);
      return `${firstName} ${shortLastName}`;
    },
    advocateInfo() {
      return this.hasCookiedAdvocate
        ? this.advocateCookieInfo
        : this.advocateRecord;
    },
    hasCookiedAdvocate() {
      return this.advocateCookieInfo.id !== undefined;
    },
    resetCookieUrl() {
      return this.redirectHelper.getResetCookieUrl();
    }
  },
  inject: {
    redirectHelper: { from: "redirectHelper" }
  }
};
</script>
